var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.task)?_c("confirm",{tag:"Button",attrs:{"color":_vm.color,"disabled":_vm.loadingAssign,"text":_vm.text,"title":_vm.title,"small":""},on:{"confirm":_vm.assignAgent}},[_vm._v(_vm._s(_vm.label))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }